<template>
  <div id="app" class="site-container" :class="{appPage:controlClass == 'app',noFoot:controlClass == 'mobile'}">
    <router-view></router-view>
    <router-view name="detail"></router-view>
    <footer>
        <div class="copyRight">
            <div class="f-links box">
                <router-link :to='{name:"aboutView", params:{detail_type:"mobile",aboutkey:"aboutUs"}}' class="flex-1">关于我们</router-link>
                <router-link :to='{name:"aboutView", params:{detail_type:"mobile",aboutkey:"service"}}' class="flex-1">服务内容</router-link>    
                <router-link class="flex-1" :to='{name:"aboutView", params:{detail_type:"mobile",aboutkey:"contcat"}}'>联系我们</router-link>
            </div>
            <p>粤ICP备18096877号-1  Copyright © 和数传媒  版权所有</p>
        </div> 
    </footer>
  </div>
</template>

<script>
export default {
    name: 'App',
    data () {
    	return {
    		controlClass: ""
    	}
    },
    created () {
    	this.controlClass = this.$route.params.detail_type;
    },
    watch: {
    	'$route' (to, from) {
		 	this.controlClass = this.$route.params.detail_type;
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue